module.exports = __webpack_public_path__ + "img/gd.ab061a1f.svg";